import React, { useState } from "react";
import { IconButton, Box, Avatar, Skeleton } from "@mui/material";
import { RiAccountCircleLine as AccountCircleIcon } from "react-icons/ri";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { auth } from "../../../../../Infrastructure/config";
import { AuthButton } from "./styles";
import "./styles.css";
import { Nav } from "react-bootstrap";
import { resetSteps } from "../../../../../Infrastructure/States/educatorStepsSlice";
import { useDispatch, useSelector } from "react-redux";
import { resetCoursesSteps } from "../../../../../Infrastructure/States/coursesStepsSlice";
import useAuthentication from "../../../../../Infrastructure/States/onAuthStateChange";
import { trackEvent } from "../../../../../Infrastructure/Utilities/analytics";
import AnalyticsConstants from "../../../../../Infrastructure/Constants/AnalyticsContants";
import { resetUserData } from "../../../../../Infrastructure/States/userDataSlice";
import UserVector from "../../../../../Assets/Images/vector.png"
import * as amplitude from "@amplitude/analytics-browser";
import paths from "../../../../../Infrastructure/Router/paths";
import { USER_LOGS_CLIENT } from "../../../../../Infrastructure/Constants/logsConstant";
import { safeClientLogEvent } from "../../../../../Infrastructure/Utilities/safeClientLogEvent";

const Dropdown = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { userId, clearAuth } = useAuthentication()
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false)
  const userData = useSelector((state) => state.userData.data)
  
  const handleLogout = async () => {
    dispatch(resetSteps())
    dispatch(resetCoursesSteps());
    auth.signOut();
    amplitude.reset()
    clearAuth()
    dispatch(resetUserData())
    const eventType = userData?.is_educator ? AnalyticsConstants.EDUCATOR_LOGOUT_SUCCESS : AnalyticsConstants.LEARNER_LOGOUT_SUCCESS;
    try {
      trackEvent(eventType, {});
    } catch (trackingError) {
       await safeClientLogEvent({
        ...USER_LOGS_CLIENT.TRACKING_EVENT_FAILED,
        uid: userId || null,
        source: "dropdown.jsx",
        emailInfo: null,
        metadata: null,
        error: trackingError?.message || null
      });
    }
    if (
      location.pathname === paths.dashboardPage.path ||
      location.pathname === paths.accountPage.path
    ) {
      navigate(paths.home.path);
    }
  };

  return (
    <>
      <div className="dropdown">
        <div className="dropbtn">
          {
            userData?.educator?.profile?.avatar ?
            <>
              {!imageLoaded && (
                <Skeleton variant="circular" width={40} height={40} />
              )}
              <Avatar
                alt="not found"
                src={imageError
                  ? UserVector
                  : userData?.educator?.profile?.avatar
                    ? `${userData?.educator?.profile?.avatar}?t=${Date.now()}`
                    : UserVector
                }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = UserVector;
                  setImageError(true)
                }}
                onLoad={() => setImageLoaded(true)}
                style={!imageLoaded ? { display: "none" } : {}}
              />
            </>
              :
              <IconButton
                size="large"
                edge="end"
                aria-controls="profile-menu"
                aria-haspopup="true"
              >
                <AccountCircleIcon />
              </IconButton>
          }
        </div>
        <div className="dropdown-content">
          <Nav className="flex-column">
            <Nav.Link as={Link} to={paths.dashboardPage.path} className="menuitems"  onClick={() => {
                window.location.hash = "";
              }}>
              Dashboard
            </Nav.Link>
            <Nav.Link as={Link} to={paths.accountPage.path} className="menuitems">
              Account
            </Nav.Link>
          </Nav>
          <Box display="flex" justifyContent="center" py="10px">
            <AuthButton signup="true" onClick={handleLogout}>
              Logout
            </AuthButton>
          </Box>
        </div>
      </div>
    </>
  );
};

export default Dropdown;
